import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { DashboardApi } from '../../../services'
import { StorageUtils } from '../../../store/Verification'
import { VerificationState } from '../verification.slice'

export const verifyOtpAsync = createAsyncThunk(
  'verification/verifyOtp',
  async ({ email, otp }: { email: string; otp: string }, { rejectWithValue }) => {
    try {
      const response = await DashboardApi.verifyOtp(email, otp)
      return (response as AxiosResponse<any>).data
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || 'Failed to verify OTP')
    }
  },
)

export const verifyOtpAsyncBuilder = (builder: ActionReducerMapBuilder<VerificationState>) => {
  builder
    .addCase(verifyOtpAsync.pending, (state) => {
      state.verifyLoading = true
      state.error = null
      state.message = null
    })
    .addCase(verifyOtpAsync.fulfilled, (state, action: PayloadAction<any>) => {
      state.verifyLoading = false
      state.isVerified = true
      state.verifiedEmail = action.payload.email
      state.message = action.payload.message
      StorageUtils.setVerificationState({
        email: action.payload.email,
        isVerified: true,
        timestamp: Date.now(),
      })
    })
    .addCase(verifyOtpAsync.rejected, (state, action: PayloadAction<any>) => {
      state.verifyLoading = false
      state.error = action.payload.error
    })
}
